var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTemplateIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Template_Icon_2",
    "data-name": "Template Icon 2",
    d: "M-5865,19468h-16a1,1,0,0,1-1-1v-16a1,1,0,0,1,1-1h16a1,1,0,0,1,1,1v16A1,1,0,0,1-5865,19468Zm-6-9.8a1,1,0,0,0-1,1v3.8a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1v-3.8a1,1,0,0,0-1-1Zm-6,0a1,1,0,0,0-1,1v3.8a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1v-3.8a1,1,0,0,0-1-1Zm-.1-4.2a.9.9,0,0,0-.9.9.9.9,0,0,0,.9.9h8.2a.9.9,0,0,0,.9-.9.9.9,0,0,0-.9-.9Z",
    transform: "translate(5882.002 -19450.002)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTemplateIn);
export default __webpack_public_path__ + "static/media/menu_template_in.5e133349db089923d7c45023280a64b6.svg";
export { ForwardRef as ReactComponent };